import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from "react-i18next"
import { fetchQrByToken } from '../actions/qrs'
import AppHeader from '../containers/AppHeader'

class HomeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      forwardScreen: false
    }

    this.goToZones = this.goToZones.bind(this);
    this.goToOTO = this.goToOTO.bind(this);
    this.goToTime = this.goToTime.bind(this);
    this.injectCSSVariables = this.injectCSSVariables.bind(this);
  }

  injectCSSVariables(qr) {
    // Inject CSS custom properties for dynamic theming
    if (qr?.headerConfig) {
      const root = document.documentElement;
      const { primaryColor, secondaryColor, textPrimary, backgroundColor, backgroundImage, backgroundSmartphoneImage } = qr.headerConfig;
      
      root.style.setProperty('--customer-primary', primaryColor || '#01315f');
      root.style.setProperty('--customer-secondary', secondaryColor || '#067ddb');
      root.style.setProperty('--customer-text-primary', textPrimary || '#01315f');
      root.style.setProperty('--customer-gradient', 
        primaryColor && secondaryColor 
          ? `linear-gradient(90deg, ${primaryColor} 0%, ${secondaryColor} 100%)` 
          : 'linear-gradient(45deg, #01315f, #067ddb)'
      );

      // Set background color (hex) for both mobile and desktop
      if (backgroundColor) {
        root.style.setProperty('--customer-background-color', backgroundColor);
      } else {
        root.style.setProperty('--customer-background-color', '#f3f3f3');
      }

      // Set background image for smartphone
      if (backgroundSmartphoneImage) {
        root.style.setProperty('--customer-background-smartphone', `url(${backgroundSmartphoneImage})`);
      } else {
        root.style.setProperty('--customer-background-smartphone', 'none');
      }

      // Set background image for desktop
      if (backgroundImage) {
        root.style.setProperty('--customer-background-image', `url(${backgroundImage})`);
      } else {
        root.style.setProperty('--customer-background-image', 'none');
      }
    }
  }

  goToZones(e) {
    const { id } = this.props.match.params;
    const { qr } = this.props;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push(`/zoneSelectorView/${id}`, {
          qrMode: qr.Mode
        });
      }
    );
  }

  goToBaqueiraZones(e) {
    const { id } = this.props.match.params;
    const { qr } = this.props;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push(`/zoneSelectorBaqueiraView/${id}`, {
          qrMode: qr.Mode
        });
      }
    );
  }

  goToOTO(e) {
    const { id } = this.props.match.params;
    const { qr } = this.props;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push(`/otoSelectorView/${id}`, {
          qrMode: qr.Mode
        });
      }
    );
  }

  goToRentalZones(e) {
    const { id } = this.props.match.params;
    const { qr } = this.props;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push(`/zoneSelectorRentalView/${id}`, {
          qrMode: qr.Mode
        });
      }
    );
  }

  goToTime(e) {
    const { id } = this.props.match.params;
    const { qr } = this.props;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push(`/timeSelectorView/${id}`, {
          qrMode: qr.Mode
        });
      }
    );
  }

  getBrowserLanguage() {
    let language = navigator.language || navigator.userLanguage;

    return language.split('-')[0]
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const browserLanguage = this.getBrowserLanguage();
    this.props.i18n.changeLanguage(browserLanguage);
    this.props.fetchQrByToken(id);

    // Initialize CSS variables from localStorage for page reloads
    const storedQrData = localStorage.getItem('qrData');
    if (storedQrData) {
      try {
        const qrData = JSON.parse(storedQrData);
        this.injectCSSVariables(qrData);
      } catch (e) {
        console.error('Failed to parse stored QR data:', e);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Check if qr prop has changed
    if (this.props.qr !== prevProps.qr && this.props.qr) {
      const { qr } = this.props;

      console.log("API response:", qr)

      // Store QR data in localStorage for persistence across reloads
      if (qr) {
        localStorage.setItem('qrData', JSON.stringify(qr));
        // Inject CSS variables for dynamic theming
        this.injectCSSVariables(qr);
      }

      // Access qr.Mode safely after the data is fetched and qr is defined
      switch (qr.Mode) {
        case 0:
          this.goToZones();
          break;
        case 1:
          this.goToOTO();
          break;
        case 2:
          this.goToBaqueiraZones();
          break;
        case 3:
          this.goToZones();
          break;
        case 4:
          this.goToRentalZones();
          break;
        case 5:
          this.goToTime();
          break;
        default:
          console.error("Unexpected qr.Mode value or qr is undefined");
      }
    }
  }

  render() {
    const { t, i18n, qr } = this.props

    if (!qr) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    return (
      <div>
        <AppHeader />
        <div className="lockerContainer mt-5">
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('PARECE QUE ALGO HA FALLADO')}</span>
          </h3>
          <div className="col-xs-12">
            <img src="/images/incidences.svg" alt="Error!" className="lockerAccessibilityImg" />
          </div>
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('VUELVE A ESCANEAR EL QR')}</span>
          </h3>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qr: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchQrByToken: bindActionCreators(fetchQrByToken, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(HomeView));